<template>
    <div class="input-group-sm" style="display: inline-block;">
        <select class="form-control" v-model="selectedStore">
            <option v-for="option in stores" :key="option.id" v-bind:value="option.id">
                {{ option.name }}
            </option>
        </select>
    </div>
</template>
<script>
import userService from '@/service/userService'
import axios from 'axios'
import un from 'underscore'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'

export default {
    name: "StoreSelect",
    data: () => ({
        mainPresenter: new MainPresenter(),
        stores: []
    }),
    computed: {
        selectedStore: {
            get() {
                return userService.getCurrentStore()
            },
            set(newStore) {
                this.changeStore(newStore)
            }
        }
    },
    created() {
        this.loadStores()
    },
    methods: {
        changeStore(newStore) {
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/users/updateUserStore/' + newStore,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            })
            req.then(res => {
                userService.saveCurrentStore(newStore)
                this.$router.go()
            }).catch(err => {
                console.log(err)
            })
        },
        loadStores() {
            axios.get(this.mainPresenter.buildUrlWithDefaults("/allStores?visible=true")).then(response => {
                this.stores = un.union(this.stores, response.data.content);
            }, err => {
                console.log(err.response);
                this.stores = [{id:0,name:"Error"}];
                this.selectedStore = this.stores[0].id;
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/utils/StoreSelect.vue